import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

const PieRechartComponent = ({ data, breakdownData }) => {
   if (!data || data.length === 0) {
      return <div className='mt-4 p-2'>No data available</div>;
   }
   const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

   const CustomTooltip = ({ active, payload }) => {
      if (active && payload && payload.length) {
         const locName = payload[0].name;
         const breakdown = breakdownData?.find(b => b.name === locName);

         return (
            <div
               className="custom-tooltip"
               style={{
                  backgroundColor: "#fff",
                  padding: "5px",
                  border: "1px solid #ccc"
               }}
            >
               <div><strong>{locName}</strong></div>
               {breakdown ? (
                  <>
                     <div>Total: {breakdown.inAgreement + breakdown.offAgreement}</div>
                     <div>InAgreement: {breakdown.inAgreement}</div>
                     <div>OffAgreement: {breakdown.offAgreement}</div>
                  </>
               ) : (
                  <div>Total: {payload[0].value}</div> // fallback
               )}
            </div>
         );
      }
      return null;
   };

   const legendFormatter = (value, entry) => {
      const count = data.find(item => item.name === entry.payload.name)?.value || 0;
      return `${value} - ${count}`;
   };

   return(
      <div className='dashboard_chart'>
         <ResponsiveContainer width="100%" height={300}>
            <PieChart>
               <Pie
                  data={data}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  outerRadius={120}
                  fill="#8884d8"
                  endAngle={360}
               >
                  {data.map((entry, index) => (
                     <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
               </Pie>
               <Tooltip content={<CustomTooltip />} />
               <Legend 
                  align="right" 
                  height={250} 
                  width={180} 
                  verticalAlign="middle" 
                  layout="vertical" 
                  formatter={legendFormatter} 
               />
            </PieChart>
         </ResponsiveContainer>
      </div>
   );
};

export default PieRechartComponent;
